module.exports = __webpack_public_path__ + "img/unknown.416bd76c.svg";